import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

if (!firebase.apps.length) {
    firebase.initializeApp({
        apiKey: "AIzaSyBLVCA6LbpX8Y6dWQWaGAf31m7Z-YcZhlU",
        authDomain: "eastwood45.firebaseapp.com",
        databaseURL: "https://eastwood45.firebaseio.com",
        projectId: "eastwood45",
        storageBucket: "eastwood45.appspot.com",
        messagingSenderId: "287256676701",
        appId: "1:287256676701:web:61364a0de86f35242300b4"
    });
}

export default firebase;